import { Body, TextInput, VStack } from '@hover/blueprint';
import type { ChangeEvent } from 'react';
import React, { useEffect, useState } from 'react';

interface RemainingTextInputProps {
  changeAction: (event: ChangeEvent<HTMLInputElement>) => void;
  value: string;
  placeholder: string;
  longLimit?: number;
  name?: string;
}

const RemainingTextInput = ({
  changeAction,
  value,
  placeholder,
  name,
  longLimit = 50,
}: RemainingTextInputProps) => {
  const [remainingCharacters, setRemainingCharacters] = useState(longLimit);

  useEffect(() => {
    setRemainingCharacters(longLimit - value.length);
  }, [value, longLimit]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    changeAction(event);
    const usedCharacters = event.target.value.length;
    setRemainingCharacters(longLimit - usedCharacters);
  };

  return (
    <VStack width="100%">
      <TextInput
        autoComplete="off"
        autoFocus
        isInvalid={remainingCharacters < 0}
        name={name}
        onChange={handleChange}
        placeholder={placeholder}
        type="text"
        value={value}
        width="100%"
      />
      <Body
        color={remainingCharacters < 0 ? 'danger.base' : 'neutral.400'}
        textAlign="right"
        width="100%"
      >
        {remainingCharacters}
      </Body>
    </VStack>
  );
};

export { RemainingTextInput };
